(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('SupplierDeliveryDetailController', SupplierDeliveryDetailController);

    SupplierDeliveryDetailController.$inject = ['$scope', '$state','MessageService', 'DeliveryRequest', 'entity', '$stateParams','$q','$filter','OrderTraces'];

    function SupplierDeliveryDetailController ($scope,$state,MessageService,DeliveryRequest, entity, $stateParams,$q,$filter,OrderTraces) {
        var vm = this;
        vm.tracesList =[];
        vm.invoice = entity;

        $q.all([vm.invoice.$promise]).then(function(){
            vm.deliveryTime =  $filter('date')(vm.invoice.deliveryTime, "yyyy-MM-dd HH:mm:ss");

            // 获取实时物流信息
            OrderTraces.getByDeliveryRequestId({deliveryRequestId: vm.invoice.id}, function(data){
                vm.tracesList = data.traces;
            })
        });

        //返回
        $scope.goBack = function () {
            $state.go("supplier-delivery",{page: $stateParams.page});
        }
    }
})();
